const prefix = '@@cart';

const SET_CART = `${prefix}/SET_CART`;

export {
    SET_CART,
};
